<template>
	<draggable
		class="list-group"
		tag="ul"
		v-model="sortedList"
		v-bind="dragOptions"
		@start="drag = true"
		@end="drag = false"
	>
		<transition-group type="transition" :name="!drag ? 'flip-list' : null">
			<li
				class="list-group-item"
				v-for="element in sortedList"
				:key="element.id"
			>
				{{ element.name }}
			</li>
		</transition-group>
	</draggable>
</template>

<script>
import draggable from 'vuedraggable';

export default {
	name: 'SingleListSort',
	components: {
		draggable,
	},
	props: {
		items: {
			required: true,
		},
		value: {
			required: true,
		},
	},
	data() {
		return {
			localItems: [...this.items],
			dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
			},
			drag: false,
		};
	},
	computed: {
		sortedList: {
			get() {
				return this.localItems;
			},
			set(v) {
				this.localItems = v;
				let sorted = v.map(o => Number(o.id));
				this.$emit('input', sorted);
			}
		}
	},
}
</script>

<style>
	.flip-list-move {
		transition: transform 0.5s;
	}
	.list-group {
		min-height: 20px;
	}
	.list-group-item {
		cursor: move;
	}
</style>